"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreSimple = void 0;
const context_1 = require("./context");
const collection_1 = require("./collection");
const query_1 = require("./query");
const converter_1 = require("./converter");
class FirestoreSimple {
    constructor(firestore) {
        this.context = new context_1.Context(firestore);
    }
    collection({ path, encode, decode }) {
        const factory = new CollectionFactory({
            context: this.context,
            encode,
            decode,
        });
        return factory.create(path);
    }
    collectionFactory({ encode, decode }) {
        return new CollectionFactory({
            context: this.context,
            encode,
            decode,
        });
    }
    collectionGroup({ collectionId, decode }) {
        const query = this.context.firestore.collectionGroup(collectionId);
        const converter = new converter_1.Converter({ decode });
        return new query_1.Query(converter, this.context, query);
    }
    async runTransaction(updateFunction) {
        return this.context.runTransaction(updateFunction);
    }
    async runBatch(updateFunction) {
        return this.context.runBatch(updateFunction);
    }
}
exports.FirestoreSimple = FirestoreSimple;
class CollectionFactory {
    constructor({ context, encode, decode }) {
        this.context = context;
        this.encode = encode;
        this.decode = decode;
    }
    create(path) {
        return new collection_1.Collection({
            context: this.context,
            path,
            encode: this.encode,
            decode: this.decode,
        });
    }
}
//# sourceMappingURL=firestore_simple.js.map